const colors = {
  secondary: 'var(--color-secondary)',
} as const;

export const getColors = () => colors;
